import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ReadOnlyPanel from "editor/components/ReadOnlyPanel";
import { API_TO_URL } from "config/constants/editor";
import { hydrateAndLockItem } from "editor/actions/locking";

class DifferentTabLockedContainer extends React.Component {
  constructor() {
    super();

    this.hydrateAndLock = this._hydrateAndLock.bind(this);
  }

  _hydrateAndLock() {
    this.props.hydrateAndLockItem(this.props.id);
  }

  render() {
    return (
      <>
        {this.props.children}
        <ReadOnlyPanel
          isVisible={
            this.props.differentTabLocked ||
            (!!this.props.lock && !this.props.lock.locked_by_this_session)
          }
          description={`You’ve been working on this ${
            API_TO_URL[this.props.contentType]
          } somewhere else. Would you like to work on it here?`}
          button="Start writing"
          onClick={this.hydrateAndLock}
          key="different-tab-locked"
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  differentTabLocked: state.editor.status.differentTabLocked,
  contentType: state.editor.status.editorType.name,
  id: state.editor.form.id,
  lock: state.editor.status.lock,
});

const mapDispatchToProps = {
  hydrateAndLockItem,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DifferentTabLockedContainer);

DifferentTabLockedContainer.propTypes = {
  differentTabLocked: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired,
  hydrateAndLockItem: PropTypes.func.isRequired,
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  lock: PropTypes.shape({
    locked_by_this_session: PropTypes.bool,
  }),
};
